import React from 'react';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';

class CustomChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [],
      options: {
        chart: {
          height: 350,
          type: 'bar',
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            distributed: false,
            borderRadius: 5,
            colors: {
              ranges: [{
                from: 0,
                to: Infinity,
                color: '#7550F6'
              }]
            },
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: '12px'
            }
          }
        }
      }
    };
  }

  componentDidMount() {
    this.fetchChartData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedMonth !== this.props.selectedMonth) {
      this.fetchChartData();
    }
  }

  fetchChartData = async () => {
    try {
      let response;
      if (this.props.selectedMonth) {
        response = await axios.post('https://zingapi.beeinnovations.com/boxoffice_app/date_wise_users.php', {
          month: this.props.selectedMonth
        });
      } else {
        response = await axios.get('https://zingapi.beeinnovations.com/boxoffice_app/date_wise_users.php');
      }

      const data = response.data.date_wise_users;
      const categories = data.map(item => item.date);
      const seriesData = data.map(item => item.count);

      this.setState({
        series: [{
          data: seriesData
        }],
        options: {
          ...this.state.options,
          xaxis: {
            categories: categories
          }
        }
      });
    } catch (error) {
      console.error('Error fetching chart data:', error);
    }
  };

  render() {
    return (
      <div id="custom-chart">
        <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={350} />
      </div>
    );
  }
}

export default CustomChart;
